import SatisfactionMessageModal from './SatisfactionMessageModal';

export default SatisfactionMessageModal;
